import Vue from 'vue';
import VueI18n from 'vue-i18n';
import uz from '../translations/uz';
import ru from '../translations/ru';
import en from '../translations/en';
import {UseLanguageStorage} from "@/services/LanguageStorage";


Vue.use(VueI18n);
const {getLang} = UseLanguageStorage()


const i18n = new VueI18n({
	locale: getLang(),
	messages: { uz, ru, en },
});



export default i18n;
